
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invoices/events-overview",
      function () {
        return require("private-next-pages/invoices/events-overview.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invoices/events-overview"])
      });
    }
  